import { HASHRATE, getHashrateUnit } from 'src/api/HashrateFormatter';
import { getSubAccountAlerts } from './API';

const formatHashrate = hashrate => {
  if(hashrate === 0){
    return 'N/A'
  }
  const hashrateUnit = getHashrateUnit(hashrate, HASHRATE.GHS);
  return hashrateUnit.formatToHashrateString(hashrate * HASHRATE.GHS.one);
}

const GetSubAccountAlerts = async (accessToken, coin, sort, groupIdsList, triggeredOnly) => {
  try {
    const response = await getSubAccountAlerts(accessToken, coin, sort, groupIdsList, triggeredOnly);
  
    const subAccountAlerts = response.data.alerts.map(i => ({
      alertId: i.alertId,
      hashrateThreshold: i.hashrateThreshold > 0 ? formatHashrate(i.hashrateThreshold).split('/')[0] : null,
      activeWorkersThreshold: i.activeWorkersThreshold,
      alertType: { hashrate: i.hashrateThreshold > 0 ? true : false, workers: i.activeWorkersThreshold > 0 ? true : false},
      emailList: i.emailList,
      groupName: i.groupName,
      subAccountName: i.subAccountName,
      isTriggered: i.isTriggered,
      alertInfo: i.alertInfo !== null ? {
        hashrate: i.hashrateThreshold > 0 && i.alertInfo.hashrate > 0 ? formatHashrate(i.alertInfo.hashrate).split('/')[0] : 
        i.hashrateThreshold > 0 && i.alertInfo.hashrate === 0 ? `0 ${formatHashrate(i.hashrateThreshold).split('/')[0]?.split(' ')[1]}` : null,
        workers: i.activeWorkersThreshold > 0 ? i.alertInfo.activeWorkers : null,
      } : null
    }));

    return { success: true, data: subAccountAlerts };
  } catch (error) {
    console.log('Error getting sub-account alerts: ', error.message);
    return { success: false, data: 'Error: API server is down or alerts are not available' };
  }
};

export default GetSubAccountAlerts;
